(function (app) {

    var baseView = Backbone.View.extend({
        initialize: function () {
            _.bindAll(this, '_update', '_subscribe', '_init');
            this._init();
            app.checkout.orderXhr.done(this._subscribe);
        },
        _init: function() {},
        _subscribe: function () {
            this.listenTo(this.model, 'change', this._update);
            this._update();
        },
        _update: function () {}
    });

    var subscriptionView = baseView.extend({
        el: '@subscription-wrapper',
        _init: function () {
            this.$title = this.$('@subscription-name');
            this.$amount = this.$('@subscription-price');
            this.$subscription_title = this.$('@subscription-title');
            this.$subscription = this.$('@subscription-table');
            this.$into = this.$('@subscription-info');
        },
        _update: function () {
            var isOurpaySelect = this.model.get('OurpaySelectSelected');
            var amount = this.model.get('Amount') || 0;
            this.$el.toggleClass('hidden-block', !isOurpaySelect || !amount);

            this._setAmount(amount);
            this._setTitle(this.model.get('InitialCount'));
            this._setInfo();
            this.$subscription_title.toggleClass('hidden-block', this.model.get('Purchased'));
            this.$subscription.toggleClass('hidden-block', this.model.get('Purchased'));
            this.$el.toggleClass('hidden-block', !isOurpaySelect);
        },
        _setAmount: function (value) {
            value && this.$amount.text(window.toMoney(value, GlobalSettings.CurrencySign));
        },
        _setTitle: function (value) {
            this.$title.text(GetPageTemplate('_Today') + ' ' + value + ' ' + GetPageTemplate('_DiscountedDeliveries'));
        },
        _setInfo: function () {
            var text = '';
            var freeDeliveryQty = '<strong>' + this.model.get('RemainingCount') + ' ' + GetPageTemplate('_DiscountedDeliveries') + '</strong>';
            if (this.model.get('Purchased') === true) {
                text = '';//GetPageTemplate('_Ops_info_remaining_after_purchase');
            }
            if (this.model.get('Purchased') === false) {
                if (this.model.get('InitialCount') === this.model.get('RemainingCount')) {
                    text = '';//GetPageTemplate('_Ops_info_remaining_before_purchase_free_delivery');
                } else {
                    text = GetPageTemplate('_Ops_info_remaining_before_purchase');
                }
            }

            this.$into.html(text.replace('[[FreeDeliveryQty]]', freeDeliveryQty));
            this.$into.removeClass('hidden-block');
        }
    });

    $(function() {
        new subscriptionView({ model: app.models.packageDetails });
    });
})(app);